const repairLog = {
  backbtn: "Go Back",
  title: "CREATE A NEW REPAIR LOG",
  tag: "Equipment TAG",
  createdby: "Created By",
  log: "Log",
  submitbtn: "SUBMIT"
};

export default repairLog;
